var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvideFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_54530)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5414 18.0159L13.1738 16.4247L10.9179 16.0969L9.90906 14.0527L8.90018 16.097L6.64429 16.4248L8.27667 18.0159L7.89134 20.2627L9.90906 19.2019L11.9268 20.2627L11.5414 18.0159ZM10.8494 18.7798L9.90906 18.2854L8.96873 18.7798L9.14831 17.7327L8.38757 16.9912L9.43887 16.8384L9.90906 15.8858L10.3792 16.8384L11.4305 16.9912L10.6698 17.7327L10.8494 18.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.54145 18.0159L6.17383 16.4247L3.91791 16.0969L2.90906 14.0527L1.90018 16.097L-0.355713 16.4248L1.27667 18.0159L0.891338 20.2627L2.90906 19.2019L4.92681 20.2627L4.54145 18.0159ZM3.84938 18.7798L2.90906 18.2854L1.96873 18.7798L2.14831 17.7327L1.38757 16.9912L2.43887 16.8384L2.90906 15.8858L3.37922 16.8384L4.43055 16.9912L3.6698 17.7327L3.84938 18.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5414 18.0159L20.1738 16.4247L17.9179 16.0969L16.9091 14.0527L15.9002 16.097L13.6443 16.4248L15.2767 18.0159L14.8913 20.2627L16.9091 19.2019L18.9268 20.2627L18.5414 18.0159ZM17.8494 18.7798L16.9091 18.2854L15.9687 18.7798L16.1483 17.7327L15.3876 16.9912L16.4389 16.8384L16.9091 15.8858L17.3792 16.8384L18.4305 16.9912L17.6698 17.7327L17.8494 18.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.2424 0H1.75805C0.788797 0 0.000244141 0.788553 0.000244141 1.75781V9.45311C0.000244141 10.4224 0.788797 11.2109 1.75805 11.2109H8.19503L9.58589 12.6018C9.7003 12.7162 9.85026 12.7734 10.0002 12.7734C10.1501 12.7734 10.3001 12.7162 10.4145 12.6018L11.8053 11.2109H18.2423C19.2116 11.2109 20.0001 10.4224 20.0001 9.45311V1.75781C20.0002 0.788553 19.2117 0 18.2424 0ZM18.8283 9.45311C18.8283 9.77619 18.5655 10.039 18.2424 10.039H11.5627C11.4073 10.039 11.2583 10.1008 11.1484 10.2107L10.0002 11.3588L8.85202 10.2107C8.74218 10.1008 8.59312 10.039 8.43773 10.039H1.75805C1.43497 10.039 1.17212 9.77619 1.17212 9.45311V1.75781C1.17212 1.43472 1.43497 1.17187 1.75805 1.17187H18.2424C18.5655 1.17187 18.8283 1.43472 18.8283 1.75781V9.45311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.5625 2.53906H3.4375C3.11391 2.53906 2.85156 2.80141 2.85156 3.125C2.85156 3.44859 3.11391 3.71094 3.4375 3.71094H16.5625C16.8861 3.71094 17.1484 3.44859 17.1484 3.125C17.1484 2.80141 16.8861 2.53906 16.5625 2.53906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.5625 5.03906H3.4375C3.11391 5.03906 2.85156 5.30141 2.85156 5.625C2.85156 5.94859 3.11391 6.21094 3.4375 6.21094H16.5625C16.8861 6.21094 17.1484 5.94859 17.1484 5.625C17.1484 5.30141 16.8861 5.03906 16.5625 5.03906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.8125 7.53906H3.4375C3.11391 7.53906 2.85156 7.80141 2.85156 8.125C2.85156 8.44859 3.11391 8.71094 3.4375 8.71094H7.8125C8.13609 8.71094 8.39844 8.44859 8.39844 8.125C8.39844 7.80141 8.13609 7.53906 7.8125 7.53906Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_54530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideFeedback);
export default __webpack_public_path__ + "static/media/provide_feedback.6e8642668b232411eab631782235edbc.svg";
export { ForwardRef as ReactComponent };